import store from './store';
import SelectionUI from "./tools/SelectionUI";
import * as SelectTool from "./tools/SelectTool";
import * as DirectSelectTool from "./tools/DirectSelectTool";
import * as RectTool from "./tools/RectTool";
import * as CircleTool from "./tools/CircleTool";
import * as RingTool from "./tools/RingTool";
import * as LineTool from "./tools/LineTool";
import * as PolylineTool from "./tools/PolylineTool";
import * as TextTool from "./tools/TextTool";
import { useEffect } from 'react';
import { pan } from './canvasSlice';
import { activateTool } from './toolSlice';


export default function EventLayer(props) {

    const handleMouseDown = (e) => {
        e.preventDefault();
        switch (store.getState().tool.activeTool) {
            case "Select":
                SelectTool.mouseDown(e, props.scene);
                break;
            case "Rect":
                RectTool.mouseDown(e, props.scene);
                break;
            case "Ellipse":
                CircleTool.mouseDown(e, props.scene);
                break;
            case "Ring":
                RingTool.mouseDown(e, props.scene);
                break;
            case "DirectSelect":
                DirectSelectTool.mouseDown(e, props.scene);
                break;
            case "Line":
                LineTool.mouseDown(e, props.scene);
                break;
            case "Pen":
                PolylineTool.mouseDown(e, props.scene);
                break;
            default:
                break;
        }
    };

    // const handleMouseDown = useCallback((e) => {
    //     console.log("mouse down", e);
    // }, []);

    const handleMouseMove = (e) => {
        e.preventDefault();
        switch (store.getState().tool.activeTool) {
            case "Select":
                SelectTool.mouseMove(e, props.scene, props.renderer);
                break;
            case "Rect":
                RectTool.mouseMove(e, props.scene);
                break;
            case "Ellipse":
                CircleTool.mouseMove(e, props.scene);
                break;
            case "Ring":
                RingTool.mouseMove(e, props.scene);
                break;
            case "DirectSelect":
                DirectSelectTool.mouseMove(e, props.scene);
                break;
            case "Line":
                LineTool.mouseMove(e, props.scene);
                break;
            case "Pen":
                PolylineTool.mouseMove(e, props.scene);
                break;
            default:
                break;
        }
    };

    const handleMouseUp = (e) => {
        e.preventDefault();
        switch (store.getState().tool.activeTool) {
            case "Select":
                SelectTool.mouseUp(e, props.scene, props.renderer);
                break;
            case "Rect":
                RectTool.mouseUp(e, props.scene, props.datasets, props.renderer, props.undoStack, props.updateUndoStack);
                store.dispatch(activateTool("Select"));
                break;
            case "Ellipse":
                CircleTool.mouseUp(e, props.scene, props.datasets, props.renderer, props.undoStack, props.updateUndoStack);
                store.dispatch(activateTool("Select"));
                break;
            case "Ring":
                RingTool.mouseUp(e, props.scene, props.datasets, props.renderer, props.undoStack, props.updateUndoStack);
                store.dispatch(activateTool("Select"));
                break;
            case "Line":
                LineTool.mouseUp(e, props.scene, props.datasets, props.renderer, props.undoStack, props.updateUndoStack);
                store.dispatch(activateTool("Select"));
                break;
            case "DirectSelect":
                DirectSelectTool.mouseUp(e, props.scene);
                break;
            case "Pen":
                PolylineTool.mouseUp(e, props.scene, props.datasets, props.renderer, props.undoStack, props.updateUndoStack);
                break;
            case "Text":
                TextTool.mouseUp(e, props.scene, props.datasets, props.renderer, props.undoStack, props.updateUndoStack);
                store.dispatch(activateTool("Select"));
                break;
            default:
                break;
        }
    };

    const handleDoubleClick = (e) => {
        switch (store.getState().tool.activeTool) {
            case "Select":
                SelectTool.doubleClick(e, props.scene);
                break;
            default:
                break;
        }
    };


    useEffect(() => {
        document.getElementById("evtLayer").addEventListener('wheel', e => {
            e.preventDefault();
            store.dispatch(pan({"x": e.deltaX, "y": e.deltaY}));
        })
    }, []);

    return (
        <svg
            id="evtLayer"
            className="canvas"
            onDoubleClick={handleDoubleClick}
            onMouseDown={handleMouseDown}
            onMouseMove={handleMouseMove}
            onMouseUp={handleMouseUp}
        >
            <SelectionUI scene={props.scene} renderer={props.renderer}></SelectionUI>
            <rect id="rectToolUI" style={{"stroke": "#1592e6", "strokeWidth": "1.5px", "visibility": "hidden", "fillOpacity": "0"}}></rect>
            <circle id="circleToolUI" style={{"stroke": "#1592e6", "strokeWidth": "1.5px", "visibility": "hidden", "fillOpacity": "0"}}></circle>
            <line id="lineToolUI" style={{"stroke": "#1592e6", "strokeWidth": "1.5px", "visibility": "hidden"}}></line>
            <path id="polylineToolUI" style={{"stroke": "#1592e6", "strokeWidth": "1.5px", "visibility": "hidden"}}></path>
            <circle id="ringToolOuterUI" style={{"stroke": "#1592e6", "strokeWidth": "1.5px", "visibility": "hidden", "fillOpacity": "0"}}></circle>
            <circle id="ringToolInnerUI" style={{"stroke": "#1592e6", "strokeWidth": "1.5px", "visibility": "hidden", "fillOpacity": "0"}}></circle>
        </svg>
    )

}